import { Link } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { JSX } from "react";

export const DataManagementHeader = (): JSX.Element => {
    return (
        <div className={"p-data-management__header"}>
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /
                    Vestiging / Gegevens beheren
                </span>
            </div>
        </div>
    );
};
